/*
 * @Author: xiaolong.xu
 * @Date: 2023-08-10 14:27:45
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-10-24 17:48:37
 * @Description: file content
 */
import React, { useEffect } from 'react'
import { ConfigProvider, Empty } from 'antd'
import { observer, useLocalObservable } from 'mobx-react-lite'
import zh_CN from 'antd/lib/locale-provider/zh_CN'
import en_US from 'antd/lib/locale-provider/en_US'
import { useRouter } from 'next/router'
import { AuthorizedPage } from '@/components/Authorized'
import { CcHelper, LeadGeneration, IMBadge } from '@/page-components/components'
import globalStore from '@/globalStore'
import { queryLayout, getLoginStatus } from '@/utils'
import { getCookie } from '@/utils/storage'
import { COOKIES_MAP, HOME_PATH } from '@/constants'
import config from '@/utils/config'
import Loader from './components/Loader'
import PrimaryLayout from './PrimaryLayout'
import PublicLayout from './PublicLayout'
import Mqtt from './components/Mqtt'
// import Survey from './components/Survey'
// import EventReminder from './components/EventReminder'
import './index.less'

const LayoutMap = {
  primary: PrimaryLayout,
  public: PublicLayout,
}

const Layouts = ({ app = {}, children }: any) => {
  const router = useRouter()
  const pathname: string = router.pathname
  const globalMobx = useLocalObservable(() => globalStore)
  const initialLocale = app?.pageProps?._nextI18Next?.initialLocale

  useEffect(() => {
    if (getLoginStatus()) {
      globalStore.refreshData(globalMobx.activeCorporationId).then(([_, userInfo]) => {
        if (userInfo?.accountStatus === 3 && pathname !== '/my/info ') {
          // 账号注销中
          router.push('/my/account')
        }
      })
    }
  }, [])

  useEffect(() => {
    if (window.ConverSation) {
      // 仅支持sso登录
      window.IMInstance = new window.ConverSation({
        platform: 'demand',
        jsEnv: config.APP_ENV,
        // debug: true,
      })
      const ck: string = getCookie(COOKIES_MAP.TOKEN)
      if (ck) {
        window.IMInstance?.login?.(ck)
      }
    }
    return () => {
      if (window.IMInstance) {
        window.IMInstance = null
      }
    }
  }, [])

  if (pathname === '/') {
    // 根路径返回官网
    return (
      <>
        <Loader />
        {children}
      </>
    )
  }

  const Container = LayoutMap[queryLayout(config.layouts, pathname)]
  return (
    <ConfigProvider
      locale={initialLocale?.includes('zh') ? zh_CN : en_US}
      renderEmpty={componentName => {
        if (componentName === 'Table') {
          return (
            <Empty image="/images/no-data.svg" imageStyle={{ height: 62 }} description="暂无数据" />
          )
        }
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      }}
    >
      <>
        {!config.unLoadingPage.includes(pathname) && <Loader />}
        <Container giveawayChannel={app.giveawayChannel || ''}>
          <AuthorizedPage>{children}</AuthorizedPage>
          <div style={{ height: 0, overflow: 'hidden' }}>
            {/* {['/inspiration/case', '/inspiration/template', '/works'].includes(pathname) && (
              <Survey firstLoginDate={globalStore.firstLoginDate} userInfo={globalMobx?.userInfo} />
            )} */}
            {/* {[
              HOME_PATH,
              '/inspiration/case',
              '/order',
              '/inspiration/template',
              '/works',
              '/media/creative',
              '/data/diagnosis',
            ].includes(pathname) && <EventReminder />} */}
            <LeadGeneration />
            <div
              id="converSationBtn"
              style={{ position: 'relative', height: 0, overflow: 'hidden' }}
            />
            {pathname === '/creative/mall' && <IMBadge />}
          </div>
        </Container>
        <CcHelper />
      </>
      <Mqtt />
    </ConfigProvider>
  )
}

export default observer(Layouts)
